import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Cookies } from 'react-cookie';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import Iconify from '../../../components/iconify';
import { reset, resetCourierMe } from '../../../redux/me.slice';
import { logout as authLogout } from '../../../redux/auth.slice';

const MENU_OPTIONS = [
  { label: 'Home', icon: 'eva:home-fill', url: '/' },
  { label: 'Settings', icon: 'eva:settings-2-fill', url: '/dashboard/settings' },
];

export default function AccountPopover() {
  const cookie = new Cookies();
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const account = useSelector((state) => state.account);
  const { role } = useSelector((state) => state.auth);
  const { me } = useSelector((state) => state.me);

  const handleOpen = (event) => setOpen(event.currentTarget);
  const handleClose = () => setOpen(null);

  const handleLogout = () => {
    cookie.remove('access_token', { path: '/' });
    cookie.remove('refresh_token', { path: '/' });
    cookie.remove('role', { path: '/' });
    dispatch(authLogout());
    dispatch(reset());
    dispatch(resetCourierMe());
    setOpen(null);
    navigate('/login');
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={(theme) => ({
          p: 0.5,
          border: `1px solid ${open ? theme.palette.grey[400] : 'transparent'}`,
          '&:hover': { backgroundColor: theme.palette.grey[100] },
        })}
      >
        <Avatar src={account.photoURL} alt="avatar" sx={{ width: 32, height: 32 }} />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1,
            width: 220,
            p: 0.5,
          },
        }}
      >
        <Box sx={{ px: 1.5, py: 1.25 }}>
          <Typography variant="subtitle2" noWrap sx={{ fontWeight: 600 }}>
            {me?.fullname}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
            {me?.phone_number}
          </Typography>
        </Box>

        {role === 'VENDOR' && (
          <>
            <Divider sx={{ my: 0.5 }} />
            <Stack>
              {MENU_OPTIONS.map((option) => (
                <MenuItem key={option.label} component={Link} to={option.url} onClick={handleClose}>
                  <Iconify icon={option.icon} width={18} sx={{ mr: 1.5, color: 'text.secondary' }} />
                  {option.label}
                </MenuItem>
              ))}
            </Stack>
          </>
        )}

        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={handleLogout} sx={{ color: 'error.main', '&:hover': { backgroundColor: 'error.lighter' } }}>
          <Iconify icon="solar:logout-2-bold" width={18} sx={{ mr: 1.5 }} />
          Chiqish
        </MenuItem>
      </Popover>
    </>
  );
}
